import { all, call, put, takeEvery, takeLatest } from "redux-saga/effects";
import * as CertificateBatchService from "../../services/CertificateBatchService";
import {
  certificateBatchAudiencesFail,
  certificateBatchAudiencesRequest,
  certificateBatchAudiencesSuccess,
  certificateBatchCreateFail,
  certificateBatchCreateRequest,
  certificateBatchCreateSuccess,
  certificateBatchItemsFail,
  certificateBatchItemsRequest,
  certificateBatchItemsSuccess,
  certificateBatchListFail,
  certificateBatchListRequest,
  certificateBatchListSuccess,
  certificateBatchPreviewFail,
  certificateBatchPreviewRequest,
  certificateBatchPreviewSuccess,
} from "../slices/certificateBatchSlice";

const errorOf = (error) =>
  error?.response?.data || {
    status: error?.response?.status || 400,
    response: "SOMETHING_ELSE_WRONG",
  };

export function* loadItems({ payload }) {
  try {
    const ajax = yield call(
      CertificateBatchService.getCertificateItems,
      payload.itemType
    );
    yield put(certificateBatchItemsSuccess(ajax.data));
  } catch (error) {
    yield put(certificateBatchItemsFail(errorOf(error)));
  }
}

export function* loadAudiences() {
  try {
    const ajax = yield call(CertificateBatchService.getCertificateAudiences);
    yield put(certificateBatchAudiencesSuccess(ajax.data));
  } catch (error) {
    yield put(certificateBatchAudiencesFail(errorOf(error)));
  }
}

export function* loadPreview({ payload }) {
  try {
    const ajax = yield call(
      CertificateBatchService.previewCertificateBatch,
      payload
    );
    yield put(certificateBatchPreviewSuccess(ajax.data));
  } catch (error) {
    yield put(certificateBatchPreviewFail(errorOf(error)));
  }
}

export function* createBatch({ payload }) {
  try {
    const ajax = yield call(
      CertificateBatchService.createCertificateBatch,
      payload
    );
    yield put(certificateBatchCreateSuccess(ajax.data));
  } catch (error) {
    yield put(certificateBatchCreateFail(errorOf(error)));
  }
}

export function* loadBatches({ payload }) {
  try {
    const ajax = yield call(
      CertificateBatchService.getCertificateBatches,
      payload
    );
    yield put(certificateBatchListSuccess(ajax.data));
  } catch (error) {
    yield put(certificateBatchListFail(errorOf(error)));
  }
}

export default function* certificateBatchSaga() {
  yield all([
    takeLatest(certificateBatchItemsRequest.type, loadItems),
    takeLatest(certificateBatchAudiencesRequest.type, loadAudiences),
    // A newer preview (another item or date) cancels the one still running.
    takeLatest(certificateBatchPreviewRequest.type, loadPreview),
    takeEvery(certificateBatchCreateRequest.type, createBatch),
    takeLatest(certificateBatchListRequest.type, loadBatches),
  ]);
}
